import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="tom-select-base"
export default class extends Controller {
  connect() {
    new TomSelect(this.element, {
      plugins: {
        remove_button: { title: 'Remove this item' }
      },
      onDelete: function(values) {
        return confirm(values.length > 1 ? 'Are you sure you want to remove these ' + values.length + ' items?' : 'Are you sure you want to remove this item?')
      },
      onItemAdd: function() {
        const submitButton = this.element.closest('form').querySelector('button[type="submit"]')
        if (submitButton) submitButton.focus()
      }.bind(this)
    })
  }
}